{
    "HeaderSidebar_ExpandMenu": "Menu uitvouwen (Ctrl + ])",
    "HeaderSidebar_CollapseMenu": "Menu samenvouwen (Ctrl + [)",
    "HeaderSidebar_PinMenu": "Pinmenu uitgebreid",
    "HeaderSidebar_UnpinMenu": "Menu losmaken",
    "NAME": "HeaderSidebar"
}